// extracted by mini-css-extract-plugin
export default {"selector":"SubTabSelector-module--selector--3ab0f","item":"SubTabSelector-module--item--fd180","active":"SubTabSelector-module--active--1f3ef"};